class VoucherType {
  constructor(code, name, instruction, word) {
    this.code = code
    this.name = name
    this.instruction = instruction
    this.word = word
  }
}

// 凭证类型
export const TRANSFER = new VoucherType('transfer', '转帐凭证', '转帐凭证', '记')
export const RECEIPT = new VoucherType('receipt', '收款凭证', '涉及收款时使用', '记')
export const PAYMENT = new VoucherType('payment', '付款凭证', '涉及付款时使用', '记')
export const WRITEOFF = new VoucherType('writeoff', '冲销凭证', '应收与应付冲销时使用', '记')
export const REDACCOUNT = new VoucherType('redaccount', '红冲凭证', '红冲蓝色凭证时使用', '记')
export const RECEIPT_PAYMENT = new VoucherType('receiptPayment', '实收付凭证', '实收付凭证时使用', '记')
export const VOUCHER_TYPES = [TRANSFER, RECEIPT, PAYMENT, WRITEOFF, REDACCOUNT, RECEIPT_PAYMENT]
